import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalAlertListRedirectRoute: InvariantJiraRoute = {
	name: 'eoc-global-alerts-redirect',
	path: '/jira/ops',
	exact: true,
};
